"use client";
import { useEffect } from "react";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { usePracticeStripeConfig } from "../queries/usePracticeStripeConfig";
import { getStripe } from "../utils/getStripe";

export function PracticeStripePreloader() {
  const { tenantId } = useTenantRouteContext();
  const { data } = usePracticeStripeConfig(tenantId);
  const publishableKey = data?.publishableKey;
  const connectedAccountId = data?.connectedAccountId;

  useEffect(() => {
    if (!publishableKey) return;
    // preload failures are non-fatal: the form retries via getStripe on init
    getStripe(publishableKey, connectedAccountId).catch(() => {});
  }, [publishableKey, connectedAccountId]);

  return null;
}
